import { render, staticRenderFns } from "./OfferEvaluationPageCustomerOrderSelectDeal.vue?vue&type=template&id=2ef6dabc&"
import script from "./OfferEvaluationPageCustomerOrderSelectDeal.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageCustomerOrderSelectDeal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef6dabc')) {
      api.createRecord('2ef6dabc', component.options)
    } else {
      api.reload('2ef6dabc', component.options)
    }
    module.hot.accept("./OfferEvaluationPageCustomerOrderSelectDeal.vue?vue&type=template&id=2ef6dabc&", function () {
      api.rerender('2ef6dabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageCustomerOrderSelectDeal.vue"
export default component.exports